import React from "react";
import './Logo.css';

export default function Logo() {
	return <div className={'logo'}/>;
}